
import Vue from 'vue';

export default Vue.extend({
	name: 'OpeningHoursContent',

	props: {
		canExtend: {
			type: Boolean,
			default: false
		},
		truck: {
			type: Object,
			default: null
		}
	},

	methods: {
		formatOpeningHours(day: { open: boolean; start: string | null; end: string | null } | undefined): string {
			if (!day) {
				return this.$t('general.closed').toString();
			}

			if (day.open && day.start === null && day.end === null) {
				return this.$t('general.open_24_hours').toString();
			} else if (day.open && day.start && day.end) {
				return `${day.start} - ${day.end}`;
			} else if (day.open && day.start) {
				return `${day.start} - ${this.$t('general.closed')}`;
			} else if (day.open && day.end) {
				return `${this.$t('general.closed')} - ${day.end}`;
			} else {
				return this.$t('general.closed').toString();
			}
		}
	}
});
